import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { initializeIcons } from '@fluentui/react';
import { useAuth } from '@auth';
import apiClient from '@api/client';
import { router } from '@router';
import { ConnectWiseLinkProvider } from '@/connectwise';
import { AppUpdatePrompt } from '@components/AppUpdatePrompt';
import './App.css';

// Initialize Fluent UI icons
initializeIcons();

function App() {
  const { acquireToken } = useAuth();

  // Setup API client token provider (silent + interactive fallback)
  useEffect(() => {
    apiClient.setTokenProvider(async () => {
      try {
        return await acquireToken();
      } catch (error) {
        console.error('Failed to acquire token for API request:', error);
        return null;
      }
    });
  }, [acquireToken]);

  return (
    <ConnectWiseLinkProvider>
      <AppUpdatePrompt />
      <RouterProvider router={router} />
    </ConnectWiseLinkProvider>
  );
}

export default App;
